import { PermissionsDisplay } from '@components/DeveloperPortal/CreateBot/PermissionsDisplay'
import { Permission } from '@towns-protocol/web3'
import { Box, Icon, Stack, Text } from '@ui'
import { type BotData } from 'use-towns-client'

interface BotAuthorizationDisplayProps {
    bot: BotData | undefined
    label?: string
}

export const BotAuthorizationDisplay = ({ bot, label }: BotAuthorizationDisplayProps) => {
    return (
        <Stack gap="lg" alignItems="center">
            <Stack gap="md" alignItems="center">
                <Box position="relative">
                    <Box
                        as="img"
                        src={bot?.metadata?.avatarUrl}
                        width="x12"
                        height="x12"
                        aspectRatio="1/1"
                        rounded="full"
                        objectFit="cover"
                    />
                    <Box
                        centerContent
                        position="absolute"
                        rounded="full"
                        width="x4"
                        height="x4"
                        background="botGradient"
                        bottom="none"
                        right="none"
                    >
                        <Icon type="robot" size="square_sm" />
                    </Box>
                </Box>

                <Text fontWeight="strong" fontSize="lg">
                    {bot?.metadata?.displayName || bot?.clientAddress}
                </Text>
                <Text color="gray2">{label || 'requests the following permissions'}</Text>
            </Stack>

            <Box padding="md" background="level2" rounded="sm" width="100%">
                <PermissionsDisplay
                    permissions={(bot?.permissions || []) as Permission[]}
                    mode="view"
                />
            </Box>
        </Stack>
    )
}
